import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Tile = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	border: 1px solid ${colors.grey3};
	border-radius: 1px;
	width: 100%;
	margin-right: 24px;
	padding: 12px 16px;
	cursor: pointer;

	&:hover {
		background-color: ${colors.green0};
	}

	&:last-child {
		margin-right: 0;
	}
`;

export const IconWrapper = styled.div`
	color: ${colors.grey8};
	font-size: 16px;
	letter-spacing: 0.3px;
	margin-bottom: 5px;
	padding-top: 5px;
`;

export const TileTitle = styled.div`
	color: ${colors.grey8};
	font-size: 16px;
	letter-spacing: 0.3px;
	font-weight: 700;
`;

export const TileText = styled.div`
	color: ${colors.grey6};
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	padding-top: 8px;
	text-align: center;

	span {
		font-weight: bold;

		&.red {
			font-weight: normal;
			color: ${colors.red1};
		}
	}
`;
